export const TextNavbarButton = {
  padding: 'Y1 Z2',
  fontWeight: '400',
  lineHeight: 0.9,
  isActive: (el) => {
    const explorer = el.getWindow('explorer')
    return explorer?.startsWith?.(el.parent.key || el.key)
  },
  onClick: (ev, el) => {
    const active = el.parent.key || el.key
    const explorer = el.getWindow('explorer')
    const isSelected = active === explorer
    const hasSelected = explorer?.startsWith?.(active)
    const val = isSelected ? null : active
    el.setWindow('explorer', val)
  },
  text: '{{ shell.app.files | polyglot }}',
  key: 'explorer',
  extends: ['CanvasButton', 'Button']
}
